export default "__VITE_ASSET__104a1830__"